import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-container" }
const _hoisted_2 = { class: "first-text" }
const _hoisted_3 = {
  key: 0,
  class: "second-text"
}
const _hoisted_4 = {
  key: 1,
  class: "second-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "staff-container",
      style: _normalizeStyle({
    border: `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
    color: `var(--components-input-${$setup.getState()}-text-color, #CDC8D7)`,
    backgroundColor: `var(--components-input-${$setup.getState()}-background-color, rgba(0, 0, 0, 0.00))`,
    fontWeight: `var(--components-input-${$setup.getState()}-font-weight, 800)`,
    borderTop: `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
  }),
      onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('change-page'))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString($setup.props.title), 1 /* TEXT */),
        ($props.lastUpdate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Última Atualização", -1 /* HOISTED */)),
              _createTextVNode(" " + _toDisplayString($setup.FormatUtils.datetime($setup.props.lastUpdate)), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, _cache[2] || (_cache[2] = [
              _createElementVNode("span", null, "O plano não possui colaboradores", -1 /* HOISTED */)
            ])))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1 /* HOISTED */))
    ], 4 /* STYLE */),
    ($setup.props.supportingText && $setup.getState() === 'error')
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "supporting-text",
          style: _normalizeStyle(`color: var(--components-input-${$setup.getState()}-supporting-text-color)`)
        }, _toDisplayString($setup.props.supportingText), 5 /* TEXT, STYLE */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}